import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../../../../state/master/services/master.service';

@Component({
  standalone: false,
  selector: 'kt-shift-detail-info',
  templateUrl: './shift-detail-info.component.html',
  styleUrls: ['./shift-detail-info.component.scss']
})
export class ShiftDetailInfoComponent implements OnInit {
  mathRef = Math;
  shiftAllInfo = null;
  isModal = false;
  showClaimShiftButton = false;
  swap = false;
  toShiftDetail = null;

  constructor(public activeModal: NgbActiveModal) {

  }
  masterBusinessLabel = MasterService.masterBusinessLabel
  ngOnInit() {
  }
  CliamShiftHandler() {

  }
}
